module.exports = __webpack_public_path__ + "static/media/RojanRijal.340fb78f.jpg";